// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "92ecaa78" + "." + "24919ac102000f3e" + ".js";
};